import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getHistoryBonusGetById = (params) => {
    return axios.get(`${backendHost}/api/admin/bonuses/history/user`, {params});
};

export {
    getHistoryBonusGetById
}